'use client';

import React from 'react';
import AppLogo from '@/components/ui/AppLogo';

interface HeaderProps {
  activePanel: number;
  totalPanels: number;
  onDotClick: (index: number) => void;
}

export default function Header({ activePanel, totalPanels, onDotClick }: HeaderProps) {
  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-8 py-5"
      style={{ background: 'rgba(245, 240, 232, 0.92)', backdropFilter: 'blur(8px)', borderBottom: '1px solid rgba(184, 175, 166, 0.3)' }}
    >
      {/* Logo */}
      <div className="flex items-center gap-3">
        <AppLogo
          size={28}
          text="Elite Consultancy"
          iconName="GlobeAltIcon"
          className="font-fraunces font-medium tracking-tight"
        />
      </div>

      {/* Scroll dots indicator */}
      <div className="flex items-center gap-2">
        {Array.from({ length: totalPanels }).map((_, i) => (
          <button
            key={i}
            onClick={() => onDotClick(i)}
            className={`scroll-dot transition-all duration-300 ${activePanel === i ? 'active' : ''}`}
            aria-label={`Go to panel ${i + 1}`}
          />
        ))}
      </div>

      {/* Right nav */}
      <nav className="flex items-center gap-6">
        <a href="#" className="nav-link hidden md:block">Archive</a>
        <a href="#" className="nav-link hidden md:block">About</a>
        <a
          href="#"
          className="font-plex-mono text-xs uppercase tracking-editorial px-4 py-2 border transition-all duration-200"
          style={{ borderColor: 'var(--vermillion)', color: 'var(--vermillion)' }}
          onMouseEnter={e => {
            (e.currentTarget as HTMLElement).style.background = 'var(--vermillion)';
            (e.currentTarget as HTMLElement).style.color = 'var(--washi)';
          }}
          onMouseLeave={e => {
            (e.currentTarget as HTMLElement).style.background = 'transparent';
            (e.currentTarget as HTMLElement).style.color = 'var(--vermillion)';
          }}
        >
          Read Guide
        </a>
      </nav>
    </header>
  );
}